function page (path) {
  return () => import(/* webpackChunkName: '' */ `~/pages/${path}`).then(m => m.default || m)
}

export default [
  { path: '/', name: 'welcome', component: page('edrr/main.vue') },
  { path: '/lang', name: 'welcome', component: page('edrr/lang.vue') },
  { path: '/game', name: 'welcome', component: page('edrr/main.vue') },
  { path: '/tool', name: 'tool', component: page('edrr/tool.vue') },
  { path: '*', component: page('errors/404.vue') }
]



// WEBPACK FOOTER //
// ./src/router/routes.js